<script>
import api from "@services/api";

export default {
  data: () => ({
    item: {}
  }),
  created() {
    this.$store.dispatch("alert/clear");
  },
  methods: {
    save() {
      if (this.item.senhaNova !== this.item.senhaNovaConfirmacao) {
        this.$store.dispatch(
          "alert/error",
          'Os campos "Nova senha" e "Confirme a nova senha" devem ser iguais.',
          { root: true }
        );
      } else {
        api.post(`api/Login/TrocarSenha`, this.item).then(response => {
          if (response.data["status"].toLowerCase() == "success") {
            this.logout();
          } else {
            throw response;
          }
        });
      }
    },
    logout() {
      this.$router.push(
        this.$route.query.redirectFrom || {
          path: `/Logout`
        }
      );
    },
    back() {
      this.$router.push(
        this.$route.query.redirectFrom || {
          path: `/`
        }
      );
    }
  }
};
</script>

<template>
  <b-form @submit.prevent="save">
    <b-form-group id="senha-antiga" label="Senha atual" label-for="senhaAntiga">
      <b-form-input
        id="senhaAntiga"
        v-model="item.senhaAntiga"
        type="password"
        autocomplete="off"
        required
      ></b-form-input>
    </b-form-group>

    <b-form-group id="senha-nova" label="Nova senha" label-for="senhaNova">
      <b-form-input
        id="senhaNova"
        v-model="item.senhaNova"
        type="password"
        autocomplete="off"
        required
      ></b-form-input>
    </b-form-group>

    <b-form-group
      id="senha-nova-confirmacao"
      label="Confirme a nova senha"
      label-for="senhaNovaConfirmacao"
    >
      <b-form-input
        id="senhaNovaConfirmacao"
        v-model="item.senhaNovaConfirmacao"
        type="password"
        autocomplete="off"
        required
      ></b-form-input>
    </b-form-group>

    <b-form-group id="button-group" class="mt-4">
      <b-button variant="light" class="btn" v-on:click="back()"
        >Cancelar</b-button
      >
      <b-button type="submit" variant="primary" class="btn ml-2"
        >Salvar</b-button
      >
    </b-form-group>
  </b-form>
</template>
